<template>
    <div class="main-container">
        <bread-crumb :items="breadcrumbPath" />
        <v-divider />
        <v-flex 
        md4 
        sm6 
        v-cloak 
        xs12
        >
            <CourseTypesTable />
        </v-flex>
    </div>
</template>
  
<script>

import CourseTypesTable from '@/views/CourseTypes/components/CourseTypesTable.vue';
import { mapGetters } from "vuex";

export default {

    components: {
        CourseTypesTable
    },
    data() {
        return {
            breadcrumbPath: [{ text: process.env.VUE_APP_SYSTEM_NAME, to: "/" }, { text: 'Course Types', to: "course-types" }],
            loading: true,
        };
    },
    computed: {
        ...mapGetters(
            [
                "editStateCoursetype",
            ]
        )
    },
    mounted() {
    },
    methods: {
    },
}
</script>
  